import { render, staticRenderFns } from "./SalesDeliveryViewLogs.vue?vue&type=template&id=99fee824"
import script from "./SalesDeliveryViewLogs.vue?vue&type=script&lang=js"
export * from "./SalesDeliveryViewLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports